import { FC, useContext } from "react";
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import FlyoutLink from "@app/shared/Flyouts/FlyoutLink";
import { KeyPointsFlyout } from "@app/projects/network-assessment/provider-hub/contract-entity-profile/KeyPointsFlyout";
import { AccessGapTypeEnum } from "@app/projects/network-assessment/provider-hub/enumerators";
import { GapRegionStatusAnnotation } from "@app/projects/network-assessment/provider-hub/GapRegionStatusAnnotation";
import { QESButtonTypeClasses } from "@app/shared/qes-standards/Button";

export const ContractEntityProfileKeyPoints: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const { selectedContractEntity } = providerHubContext;
  const providerCount = providerHubContext.selectedContractEntity.filteredServicingProviders;
  const providerSpecialties = providerHubContext.providerHubContractEntities.items
    .filter((x) => x.contractEntityId === providerHubContext.selectedContractEntity.contractEntityId)
    ?.flatMap((x) => x.unfilteredServicingSpecialties).map((x) => x.code);
  const uniqueSpecialties = Array.from(new Set(providerSpecialties));
  const specialtyCount = uniqueSpecialties.length > 0 ? uniqueSpecialties.length : providerHubContext.selectedContractEntity.filteredServicingSpecialties.length;

  return (
    <div className="provider-profile__card">
      <h4 className="provider-profile__card-title">Key Points</h4>
      <div className="provider-profile__card-content">
        <div className="provider-profile__card-values">
          <div className="provider-profile__card-highlight" aria-labelledby="providers">{providerCount}</div>
          <div className="provider-profile__card-highlight" aria-labelledby="specialties">{specialtyCount}</div>
          <div className="provider-profile__card-highlight" aria-labelledby="closes-gaps">
            {!selectedContractEntity.gapsClosed 
              ? (selectedContractEntity.gapsClosed === 0 ? selectedContractEntity.gapsClosed : "---")
                : (<FlyoutLink
                      classNames={QESButtonTypeClasses.get("link")}
                      testId="provider-profile__closes-gaps"
                      content={{
                        body: <KeyPointsFlyout gapType={AccessGapTypeEnum.FillableBySingleProvider} />,
                        title: "Gap Closure"
                      }}>
                        {selectedContractEntity.gapsClosed}
                    </FlyoutLink>)
            }
            <GapRegionStatusAnnotation
              total={selectedContractEntity.gapsClosed}
              active={selectedContractEntity.activeGapsClosed}
              pending={selectedContractEntity.pendingGapsClosed}
              approved={selectedContractEntity.approvedGapsClosed}
              opportunity={selectedContractEntity.opportunityGapsClosed}
              useGapsByRegionStatus={selectedContractEntity.useGapsByRegionStatus}
            />
          </div>
        </div>

        <div className="provider-profile__card-labels">
          <div className="provider-profile__card-subtitle" id="providers">Providers</div>
          <div className="provider-profile__card-subtitle" id="specialties">Specialty Groups</div>
          <div className="provider-profile__card-subtitle" id="closes-gaps">Closes Gaps</div>
        </div>
      </div>
    </div>
  );
};